import * as React from 'react';

import styled from 'styled-components';

import { AnimatePresence } from 'framer-motion';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

import TitleInputCtrl from '@webapp/controllers/title-input';
import { Avatar } from '@components/basics/avatar';

interface BoxTitleHeaderProps {
  className?: string;
  bigTitle?: boolean;
  isEditable?: boolean;
  placeholder?: string;
  value?: string;
  title?: React.ReactNode;
  text?: React.ReactNode;
  isAvatar?: boolean;
  onChange?: (value: string) => void;
}

export const BoxTitleHeader: React.FC<BoxTitleHeaderProps> = (props) => (
  <div className={props.className}>
    <FlexRow>
      {props.isAvatar && <Avatar className="avatar" />}
      <div>
        {props.isEditable ? (
          <TitleInputCtrl
            className="title"
            placeholder={(props.placeholder as string) || ''}
            value={props.value || ''}
            onChange={(ev) =>
              props.onChange ? props.onChange(ev.target.value) : null
            }
          />
        ) : (
          <AnimatePresence>
            <Typography
              type={props.bigTitle ? 'subheader-small' : 'big-title'}
              className="title"
              customFont="medium"
            >
              {props.title}
            </Typography>
          </AnimatePresence>
        )}
        <AnimatePresence>
          {props.text ? (
            <MotionOpacity>
              <Typography
                className="box-title-text"
                weight="400"
                type={props.bigTitle ? 'title' : 'small'}
              >
                {props.text}
              </Typography>
            </MotionOpacity>
          ) : null}
        </AnimatePresence>
      </div>
    </FlexRow>
  </div>
);

export default styled(BoxTitleHeader)`
  .avatar {
    width: 24px;
    height: 24px;
    margin-right: 20px;
  }
  .box-title-text {
    margin-top: 5px;
    color: ${({ theme }) => theme.colors.tertiary};
  }
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;
